// extracted by mini-css-extract-plugin
export default {"ordersSection":"tvBkBc08","ordersHeader":"w0u2PUzb","requestButton":"upLIV6Bx"};